<template>
  <v-card class="offMFA_card">
    <h2 class="offMFA_title">多要素認証を使用しない</h2>
    <h3 class="offMFA_caption"></h3>
    <section class="offMFA_container">
      <p>
        多要素認証設定を解除すると、ログイン時に多要素認証を確認しなくなります。<br />
        再び多要素認証を設定するには、ログイン後、メニューのセキュリティ設定から登録を行ってください。
      </p>
    </section>
    <div class="offMFA_btn_container">
      <v-btn
        block
        depressed
        large
        color="primary"
        :loading="loading"
        @click="handleSubmit"
      >
        多要素認証設定を解除
      </v-btn>
    </div>
    <footer class="offMFA_footer">
      <h5 @click="handleCancel">もどる</h5>
    </footer>
  </v-card>
</template>

<script>
export default {
  name: 'OffMFA',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async handleSubmit() {
      this.$emit('submit');
    },
    handleCancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss">
.offMFA {
  &_card {
    width: 500px;
    height: 500px;
    overflow: hidden;
    margin: 0 auto;
    margin-bottom: 110px;
    &.v-sheet.v-card:not(.v-sheet--outlined) {
      padding: 102px;
      padding-top: 30px;
      box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.06);
      background-color: #fff;
      border-radius: 10px;
    }
    .v-btn:not(.v-btn--round).v-size--large {
      height: 48px;
      border-radius: 10px;
    }

    .v-btn__content {
      font-weight: bold;
    }
    .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
      background-color: #eeeeee !important;
    }
  }
  &_title {
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
    text-align: center;
    color: #333;
  }
  &_caption {
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: #4b4b4b;
    text-align: left;
    margin: 20px auto;
  }

  &_container {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    p {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #666;

      display: inline;
    }
  }
  &_btn_container {
    text-align: center;
    margin-top: 28px;
  }
  &_error {
    &-wronginfo {
      height: 40px;
      font-size: 15px;
      font-weight: normal;
      line-height: 1.4;
      text-align: left;
      color: var(--error-color);
      margin: 0 auto;
      margin-top: 19px;
      margin-bottom: 27px;
    }
    &-gap {
      height: 30px;
    }
  }
  &_footer {
    margin: 0 auto;
    h5 {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #0075c2;
      cursor: pointer;
      text-align: center;
      margin-top: 25px;
    }
  }
}
</style>
